document.addEventListener("alpine:init", () => {
    Alpine.data("Form", () => ({
        submit: null,
        init() {
            pegasus.onResizeFinished(() => {
                setTimeout(() => {
                    this.submit = this.$el.querySelector("input[type=submit]");

                    if(this.submit) {
                        this.submit.addEventListener("click", function () {
                            setTimeout(() => {
                                document
                                    .querySelector(".Form__wrapper")
                                    .scrollIntoView();
                            }, 500);
                        });
                    }
                }, 700);
            }, true);
        },
    }));
});
